import React from "react";
import { stepFiveData } from "./stepData";
import { Link, Typography } from "@mui/material";

const StepFive = () => {
  return (
    <>
      <div>
        <div className=" mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepFiveData[0].heading}
          </Typography>
        </div>
        <ol
          style={{
            listStyle: "number",
            fontSize: 16,
            lineHeight: "24px",
            letterSpacing: "0.08px",
            fontWeight: 500,
            fontFamily: "'Archivo',sans-serif",
          }}
          className="mt-3 mb-0"
        >
          <li className="mt-2">
            Visit the SBI Home Loan EMI Calculator page{" "}
            <Link
              sx={{
                fontSize: 16,
                lineHeight: "24px",
                letterSpacing: "0.08px",
                fontWeight: 500,
                fontFamily: "'Archivo',sans-serif",
              }}
              href="https://www.sbi.co.in/"
              variant="body2"
              underline="hover"
              target="_blank"
            >
              here
            </Link>{" "}
            .
          </li>
          <li className="mt-2">
            Enter the loan amount, interest rate, and loan tenure (in years).{" "}
          </li>
          <li className="mt-2">
            Click 'Calculate EMI' to view your monthly EMI, total repayment, and
            the breakdown of principal and interest.
          </li>
          <li className="mt-2">
            Adjust loan parameters to see how different amounts, tenures, or
            interest rates impact your monthly payment.{" "}
          </li>
        </ol>
      </div>
    </>
  );
};

export default StepFive;
